import { useState } from "react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { MessageCircle, Search } from "lucide-react";
import { BRAND } from "@/mock";

const ROOM_TYPES = [
  "Any Room",
  "Single Room (Non A/C)",
  "Single Room (A/C)",
  "1 BHK Compact (A/C)",
  "1 BHK Large (A/C)",
  "2 BHK (A/C)",
  "3 BHK (A/C)",
];

const BookingBar = () => {
  const [checkIn, setCheckIn] = useState("");
  const [checkOut, setCheckOut] = useState("");
  const [roomType, setRoomType] = useState("Any Room");
  const [rental, setRental] = useState("Daily");

  const handleCheck = () => {
    const lines = [`Hi, I'd like to enquire about availability.`];
    if (checkIn) lines.push(`Check-in: ${checkIn}`);
    if (checkOut) lines.push(`Check-out: ${checkOut}`);
    lines.push(`Room: ${roomType}`);
    lines.push(`Rental: ${rental}`);
    const msg = encodeURIComponent(lines.join("\n"));
    window.open(`https://wa.me/${BRAND.whatsapp}?text=${msg}`, "_blank");
  };

  return (
    <div
      className="bg-white border-y border-[#E5E0D8] sticky top-[72px] z-40 shadow-[0_6px_24px_rgba(0,0,0,0.04)]"
      data-testid="booking-bar"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-[1fr_1fr_1.3fr_1fr_auto] gap-0 items-stretch divide-x divide-[#E5E0D8]/70">
          <Field label="Check-in">
            <Input
              type="date"
              value={checkIn}
              onChange={(e) => setCheckIn(e.target.value)}
              className="border-0 bg-transparent shadow-none focus-visible:ring-0 h-auto p-0 text-[15px] text-[#1A1A1A] font-medium"
              data-testid="booking-checkin"
            />
          </Field>
          <Field label="Check-out">
            <Input
              type="date"
              value={checkOut}
              onChange={(e) => setCheckOut(e.target.value)}
              className="border-0 bg-transparent shadow-none focus-visible:ring-0 h-auto p-0 text-[15px] text-[#1A1A1A] font-medium"
              data-testid="booking-checkout"
            />
          </Field>
          <Field label="Room Type">
            <Select value={roomType} onValueChange={setRoomType}>
              <SelectTrigger
                className="border-0 bg-transparent shadow-none focus:ring-0 h-auto p-0 text-[15px] text-[#1A1A1A] font-medium"
                data-testid="booking-room-type"
              >
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {ROOM_TYPES.map((t) => (
                  <SelectItem key={t} value={t}>
                    {t}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </Field>
          <Field label="Rental Basis">
            <Select value={rental} onValueChange={setRental}>
              <SelectTrigger
                className="border-0 bg-transparent shadow-none focus:ring-0 h-auto p-0 text-[15px] text-[#1A1A1A] font-medium"
                data-testid="booking-rental"
              >
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Daily">Daily</SelectItem>
                <SelectItem value="Monthly">Monthly</SelectItem>
              </SelectContent>
            </Select>
          </Field>
          <div className="col-span-2 lg:col-span-1 flex items-center gap-2 px-4 py-3">
            <Button
              onClick={handleCheck}
              className="flex-1 lg:flex-none bg-[#1A1A1A] hover:bg-[#2A2A2A] text-white rounded-full px-6 h-11 text-[13px] font-semibold"
              data-testid="booking-check-btn"
            >
              <span className="inline-flex items-center gap-1.5">
                <Search className="w-4 h-4" /> Check Availability
              </span>
            </Button>
            <a
              href={`https://wa.me/${BRAND.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-11 h-11 rounded-full bg-[#25D366] hover:bg-[#20b858] flex items-center justify-center text-white shadow-[0_4px_14px_rgba(37,211,102,0.35)] transition-all"
              data-testid="booking-whatsapp-btn"
              title="WhatsApp"
            >
              <MessageCircle className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const Field = ({ label, children }) => (
  <div className="px-4 md:px-5 py-3.5">
    <div className="text-[9px] tracking-[0.18em] uppercase text-[#9A9A9A] font-semibold mb-1.5">
      {label}
    </div>
    {children}
  </div>
);

export default BookingBar;
